import { heroImage } from '@/mocks/comic';

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[600px] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="嘿咻嘿咻漫画热血剧情插画背景"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-background-950/55 to-background-950/30" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background-950/70 to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-sm font-semibold text-foreground-950 whitespace-nowrap">
            <i className="ri-fire-fill" />
            剧情解析 · 追更讨论社区
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
            看懂《嘿咻嘿咻漫画》
            <span className="block text-accent-300">从剧情到结局，全在这里</span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-background-100/90 md:text-lg">
            剧情走向、结局真相、角色设定一网打尽。这里汇总了《嘿咻嘿咻漫画》的深度解析、评价与讨论，帮你快速理清故事脉络，找到同好一起追更。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#analysis"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line" />
              看剧情解析
            </a>
            <a
              href="#community"
              className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap ring-1 ring-background-50/40 backdrop-blur transition-colors hover:bg-background-50/25"
            >
              <i className="ri-chat-smile-line" />
              加入讨论
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-8">
            <div>
              <p className="font-heading text-2xl font-black text-accent-300">60+</p>
              <p className="mt-1 text-xs text-background-200">篇深度解析</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-black text-accent-300">12k+</p>
              <p className="mt-1 text-xs text-background-200">位同好追更</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-black text-accent-300">1.8w</p>
              <p className="mt-1 text-xs text-background-200">条剧情讨论</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}